import React, { useState, useEffect } from 'react';
import axiosClient from 'api/axiosClient'
import { Container, Row, Col } from 'reactstrap';
import Loader from "react-loader-spinner";
import ContentNews from './ContentNews';
import ContentLabel from './ContentLabel';
import ContentUpComing from './ContentUpComing';


export default function News({unit}) {

    const [infoLatest, setInfoLatest] = useState()
    const [infoRelated, setInfoRelated] = useState()
    const [loaded, setLoaded] = useState()
    useEffect(() => {
        // set loading to wait get data
        setLoaded(false)
        const requestUrl_1 = `/news?unit=${unit}&page=1&size=5`;
        const requestUrl_2 = `/news/getBySpotlight?unit=${unit}`;
        Promise.all([axiosClient.get(requestUrl_1), axiosClient.get(requestUrl_2)])
            .then(([firstResponse, secondResponse]) => {
                setInfoLatest(firstResponse.data)
                setInfoRelated(secondResponse.data)
                setLoaded(true)
            })
            .catch(error => console.log(error));
    }, [])

    return (
        <div className="bg-contentNew">
            <Container>
                {
                    !loaded ? <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" /> :
                        <Row>
                            <Col md={8} sm={12}>
                                <ContentLabel tittle="Latest News"></ContentLabel>
                                <ContentNews infoLatest={infoLatest}></ContentNews>
                            </Col>
                            <Col md={4} sm={12}>
                                <ContentUpComing infoRelated={infoRelated}></ContentUpComing>
                            </Col>
                        </Row>
                }

            </Container>
        </div>

    )
}
